exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "._26Cim1ZG3TUnTZJTn6jB6M{padding:5px 15px;font-size:10px;border-radius:12px;margin:4px;text-transform:uppercase;display:inline-block}._26Cim1ZG3TUnTZJTn6jB6M._2q18vBAtjE1nqeAsf85SVq{background-color:#f50;color:#fff;font-weight:700}._26Cim1ZG3TUnTZJTn6jB6M._1XhMv_YlB2JNxeWS8oO-du{background-color:#e8e8e8;color:#4a4a4a;font-weight:700}", "", {"version":3,"sources":["/Users/mrodrigo/Documents/DEV/v2APP/src/components/atoms/Tag/style.css"],"names":[],"mappings":"AAAA,yBACI,iBAAkB,AAClB,eAAgB,AAChB,mBAAoB,AACpB,WAAY,AACZ,yBAA0B,AAC1B,oBAAsB,CACzB,AACD,iDACI,sBAA0B,AAC1B,WAAY,AACZ,eAAkB,CACrB,AAED,iDACI,yBAA0B,AAC1B,cAAe,AACf,eAAkB,CACrB","file":"style.css","sourcesContent":[".tag {\n    padding: 5px 15px;\n    font-size: 10px;\n    border-radius: 12px;\n    margin: 4px;\n    text-transform: uppercase;\n    display: inline-block;\n}\n.tag.orange {\n    background-color: #ff5500;\n    color: #fff;\n    font-weight: bold;\n}\n\n.tag.grey {\n    background-color: #e8e8e8;\n    color: #4a4a4a;\n    font-weight: bold;\n}"],"sourceRoot":""}]);

// exports
exports.locals = {
	"tag": "_26Cim1ZG3TUnTZJTn6jB6M",
	"orange": "_2q18vBAtjE1nqeAsf85SVq",
	"grey": "_1XhMv_YlB2JNxeWS8oO-du"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"minimize":true,"sourceMap":true}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/atoms/Tag/style.css
// module id = 949
// module chunks = 0 1 2 3